import { useState } from "react";
import { PromptTemplateVar } from "../../../api";
import { defaultProcessingMessage, defaultTextProcess, EditVarsModalContentProps, UtilizeModalContentProps, VarElementFactory } from "./VarElementFactory";
import { ChoiceGroup, DefaultButton, IChoiceGroupOption, IconButton, PrimaryButton, Stack, TextField } from "@fluentui/react";

const EditVarsModalContent_AddText = (props: EditVarsModalContentProps) => {
    const {focusElement, vars, onVarsChanged, backToList} = props
    const [name, setName] = useState(focusElement?.name ?? "")
    const [description, setDescription] = useState(focusElement?.description ?? "")
    const [required, setRequired] = useState<string>(focusElement ? (focusElement?.is_required ? "required" : "not_required") : "")

    const options: IChoiceGroupOption[] = [
        { key: 'required', text: '必須' },
        { key: 'not_required', text: '任意' },
    ];
    const opeType = focusElement ? "修正" : "追加"
    return (
        <form onSubmit={(e) => {
            if (!e.currentTarget.checkValidity()) {
              return
            }
            e.preventDefault()
            const newVar: PromptTemplateVar = {
                id: focusElement?.id ?? window.crypto.randomUUID(),
                name: name,
                description: description,
                is_required: required === "required",
                input_type: "Text",
                elements: []
            }
            // 修正
            if(focusElement){
                const newVars = vars.map(v => v.id === newVar.id ? newVar : v)
                onVarsChanged(newVars)
            }
            // 追加
            else {
                const newVars = [...vars]
                newVars.push(newVar)
                onVarsChanged(newVars)
            }
            backToList()
        }}>
            <Stack horizontal horizontalAlign="space-between" verticalAlign="center" id="editvarsmodalcontent-header">
                <h2>
                  {`質問項目の${opeType} (自由入力)`}
                </h2>
                <IconButton
                  iconProps={{iconName: 'Cancel'}}
                  onClick={backToList}
                />
            </Stack>
            <Stack id="editvarsmodalcontent-body" tokens={{childrenGap: "15px"}} style={{maxHeight: "70vh", minHeight: "70px", overflowY: "auto"}}>
                <TextField 
                    label="質問内容" 
                    style={{width: "100%"}} 
                    maxLength={1024}
                    required 
                    placeholder="例：会議のテーマはなんですか？"
                    value={name}
                    onChange={(e) => setName(e.currentTarget.value)}
                />
                <TextField 
                    label="入力例" 
                    style={{width: "100%"}} 
                    maxLength={1024}
                    placeholder="例：新事業のキックオフ"
                    name="description"
                    value={description}
                    onChange={(e) => setDescription(e.currentTarget.value)}
                />
                <ChoiceGroup 
                    options={options} 
                    label="入力条件" 
                    required 
                    selectedKey={required}
                    onChange={(_, option) => setRequired(option?.key ?? "") }/>
                <Stack horizontal tokens={{childrenGap: "26px"}} style={{marginTop: "20px", marginBottom: "20px"}}>
                    <PrimaryButton text={opeType} type="submit" style={{width: "120px"}} />
                    <DefaultButton text="キャンセル" style={{width: "120px"}} onClick={backToList} />
                </Stack>
            </Stack>
        </form>
    )
};

const VarElement_Text = (props: UtilizeModalContentProps) => {
    const { templateVar } = props
    return (<>
      <TextField
        name       ={templateVar.id}
        label      ={templateVar.name}
        required   ={templateVar.is_required}
        placeholder={templateVar.description}
        multiline
        autoAdjustHeight
        style={{maxHeight: "200px", overflowY: "auto"}}
      />
    </>)
};

export const TextVarElementFactory: VarElementFactory = {
    inputType: "Text" as const,
    itemName: "自由入力",
    isDroppableToRequest: true,
    iconName: "FabricTextHighlight",
    editVarsModalContent: EditVarsModalContent_AddText,
    utilizeModalContent: VarElement_Text,
    processVar: defaultTextProcess,
    processingMessage: defaultProcessingMessage
}